import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getUserAccessType } from "../../Utils/index";
import { DEFAULT_IMAGE_CDN } from "@/Constants";
import { useSelector } from "react-redux";
import { RootState } from "@/Redux/Reducers";
import LogoutModal from "../LogoutModal";
import { UserAndStoreInfoProps } from "../../Types";
import { StoreCredits } from "../StoreCredits";

export function UserAndStoreInfo(props: UserAndStoreInfoProps) {
  const { storeLogo, storeName, expanded } = props;
  const userRole = useSelector((state: RootState) => state.staffManagementReducer.staffMemberData?.role);

  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <div className="tw-sticky tw-bottom-0 tw-flex tw-justify-between tw-border-t tw-border-solid tw-border-[#111C361F]  tw-bg-white tw-py-[15px] tw-pl-[16px] tw-pr-[6px]">
      <div className="tw-flex tw-gap-[12px] tw-overflow-hidden">
        <img
          className="tw-h-[32px] tw-w-[32px] tw-rounded tw-border-t tw-border-solid tw-border-[#111C361F]"
          src={storeLogo || DEFAULT_IMAGE_CDN}
        />
        <div className="tw-flex tw-flex-none tw-flex-col tw-gap-[4px] tw-text-[12px]/[15px]">
          <span className="tw-font-bold tw-text-[#111C36CC]">{storeName}</span>
          <span className="tw-font-normal tw-text-[#111C3699]">{getUserAccessType(userRole)}</span>
        </div>
      </div>
      {expanded && 
        <span className="tw-flex tw-cursor-pointer" onClick={(e) => setAnchorEl(e.target)}>
          <MoreVertIcon />
        </span>
      }
      <LogoutModal anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </div>
  );
}
